import React from 'react'
import InsightSection from '@cx/empty-state-common/components/InsightSection'
import styled, { css } from 'styled-components'
import { connect } from 'react-redux'

const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 1.4rem;
  margin-top: 1rem;
  ${({ theme: { media } }) =>
    media.medium(css`
      margin-top: 0;
      margin-left: 1.7rem;
    `)};
`
const Title = styled.h1`
  && {
    font-weight: 400;
    font-size: 1.5rem;
    margin-top: -5px;
  }
  ${({ theme: { media } }) =>
    media.medium(css`
      && {
        font-size: 2.125rem;
      }
      text-align: left;
    `)};
`

function ArticleWrapper ({ articles }) {
  return (
    <div>
      <TitleWrapper>
        <Title>Top articles from our experts</Title>
      </TitleWrapper>
      <InsightSection articles={articles} className='InvestmentInsight education-articles' />
    </div>
  )
}

const mapStateToProps = (state) => ({
  articles: state.articles
})

export default connect(mapStateToProps)(ArticleWrapper)
